import React from "react";

const BottomHero = () => {
	return (
		<div className="flex flex-col justify-center items-center bg-boost-mobile bg-violet py-20 w-full h-full lg:bg-boost-desktop lg:bg-cover lg:py-24">
			<h1 className="text-2xl font-bold text-gray-100 pb-5 lg:text-4xl">Boost your links today</h1>
			<button className="bg-cyan text-gray-100 text-lg py-3 px-8 rounded-3xl">Get Started</button>
		</div>
	);
};

export default BottomHero;
